import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please log in.");
      navigate("/login");
    } catch (err) {
      setError(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Set a new password" footer={<Link to="/login" className="text-emerald-400 hover:underline">Back to log in</Link>}>
      {!token ? (
        <p className="text-sm text-rose-400 text-center">Missing reset token. Request a new link.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label>New password</Label>
            <Input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Min 8 characters" className="bg-slate-950 border-slate-700 h-11" />
          </div>
          {error && <p className="text-sm text-rose-400">{error}</p>}
          <Button data-testid="reset-submit" type="submit" disabled={loading} className="w-full h-11 bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Update password"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
